import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import { Auth, getRedirectResult } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { FooterComponent } from '../../components/footer-main/footer-main';
import { FooterDesktopComponent } from '../../components/footer-desktop/footer-desktop';
import { HeaderComponent } from '../../components/header-main/header-main';
import { HeaderDesktopComponent } from '../../components/header-desktop/header-desktop';
import { AuthService } from '../../core/auth.service';

@Component({
    imports: [CommonModule, FooterComponent, FooterDesktopComponent, HeaderComponent, HeaderDesktopComponent, ReactiveFormsModule],
    selector: 'app-sign-up',
    styleUrls: ['./sign-up.page.scss'],
    templateUrl: './sign-up.page.html'
})
export class SignUpPage implements OnInit {
  public registerForm: any;
  isAppleLogin: boolean = false;

  constructor(
    private afAuth: Auth,
    private auth: AuthService, 
    private fb: FormBuilder, 
    private platform: Platform,
    private router: Router, 
  ) {
    let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
    this.registerForm = this.fb.group({
      email: ['', Validators.compose([Validators.required, Validators.pattern(EMAIL_REGEXP)])],
      password: ['', Validators.compose([Validators.minLength(6), Validators.required])],
    })
  }

  async registerUser() {
    await this.auth.emailSignUp(this.registerForm.value.email,this.registerForm.value.password);
  }

  async signUpWithApple() {
    await this.auth.appleLogin();
  }

  async signUpWithGoogle() {
    await this.auth.googleLogin();
  }

  ngOnInit() {
    if (this.platform.is('capacitor') || this.platform.is('cordova')) {
      if (this.platform.is('ios')) {
        this.isAppleLogin = true;
      }
      getRedirectResult(this.afAuth)
      .then(result => {
        if (result?.user) {
          return this.router.navigate(['/account/dashboard']);
        }
        return null;
      })
      .catch((error) => {
        console.error(error);
      });
    }
  }
}
